export enum Gender {
  Male = "Male",
  Female = "Female"
}

export interface UserProfile {
  id: string;
  firstName: string;
  lastName: string;
  gender: Gender;
  dateOfBirth: Date;
  grade: string;
  school: string;
  phoneNumber: string;
  email: string;
  heightFeet: number;
  heightInches: number;
  weight: number; // in pounds
  // Backward compatibility fields for web-only users
  name?: string;
  avatar?: string;
  dateJoined?: Date;
  totalWorkouts?: number;
  currentStreak?: number;
}

export interface MaxLift {
  id: string;
  userId: string;
  benchPress: number;
  deadlift: number;
  squat: number;
  clean: number;
  dateCreated: Date;
}

export interface WorkoutSet {
  id: string;
  percentage: number;
  setNumber: number;
  reps: { min: number; max: number };
  isCompleted: boolean;
  actualReps?: number;
  setWeight: number;
}

export interface LeaderboardEntry {
  id: string;
  userName: string;
  userAvatar?: string;
  value: number;
  rank: number;
}
